import { teamContext } from "@redotech/feature-flags-model/context";
import { featureFlag } from "@redotech/openfeature-contracts/flag";

/** The merchant app notification inbox. */
export const merchantNotificationsFlag = featureFlag(
  "merchant-notifications",
  teamContext,
).boolean(false);
